export default __webpack_public_path__ + "static/17799-5d857bb2f2f0ea69cfa8ee5a93a46d62.jpg";